/** Los dos íconos de la portada de "Nueva venta" — no son glifos
 *  genéricos de un set de íconos, son un puestito de feria para
 *  Empresa (así se le vende al por mayor a un negocio) y un canasto de
 *  berries para Particular (lo que se lleva una persona a su casa).
 *  Mismo trazo que el resto de la app (redondeado, currentColor) para
 *  que no desentonen, pero dibujados a mano para esta pantalla. */

export function IconoPuestoEmpresa({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      {/* Toldo escalonado */}
      <path
        d="M2.5 9 4 4.2C4.3 3.2 5.2 2.5 6.3 2.5h11.4c1.1 0 2 .7 2.3 1.7L21.5 9"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 9q1.75 2.4 3.5 0t3.5 0 3.5 0 3.5 0 3.5 0"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Postes */}
      <path d="M5.5 9v11.5M18.5 9v11.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      {/* Mesón */}
      <rect x="3.5" y="15" width="17" height="5.5" rx="1.1" stroke="currentColor" strokeWidth="1.7" />
      <path d="M3.5 17.6h17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.6" />
      {/* Cajones de fruta sobre el mesón */}
      <circle cx="9.3" cy="16.9" r="0.95" fill="currentColor" />
      <circle cx="12" cy="16.9" r="0.95" fill="currentColor" />
      <circle cx="14.7" cy="16.9" r="0.95" fill="currentColor" />
    </svg>
  )
}

export function IconoCanastoParticular({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      {/* Asa */}
      <path d="M7.2 10.5C7.6 5.8 9.5 3 12 3s4.4 2.8 4.8 7.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      {/* Canasto */}
      <path
        d="M4.6 10.5h14.8l-1.65 9.1c-.16.9-.94 1.55-1.85 1.55H8.1c-.91 0-1.69-.65-1.85-1.55L4.6 10.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M6.3 14h11.4M6.85 17.2h10.3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" opacity="0.6" />
      {/* Berries asomando por el borde */}
      <circle cx="9" cy="9.6" r="1.9" fill="currentColor" />
      <circle cx="12.3" cy="8.3" r="2.3" fill="currentColor" />
      <circle cx="15.6" cy="9.6" r="1.9" fill="currentColor" />
      <path d="M12.3 6.3v-1" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" opacity="0.85" />
    </svg>
  )
}
